<template>
    <div class="flex flex-col">
        <label v-if="label" :for="labelFor" class="text-[13px] text-white leading-loose">
            <span v-if="required">*</span> {{ label }}
        </label>
        <slot></slot>
    </div>

</template>

<script>
export default {
    props: {
        label: String,
        labelFor: String,
        required: Boolean,
    }
}
</script>
